function _0x15e7(){var _0x53d582=['115QDFHvh','6679256WJtYxO','10455yYUVtP','DOMContentLoaded','addEventListener','24086UCkbfC','6885875dmnoxk','568dUqlEH','4484032TbmIZz','4318674XFfkFn','32917851EXBSjL','Linux\x20x86_64','10FAkVLO'];_0x15e7=function(){return _0x53d582;};return _0x15e7();}var _0x6c111f=_0x5c44;function _0x5c44(_0x5e0137,_0x215a7d){var _0x15e7c5=_0x15e7();return _0x5c44=function(_0x5c44ac,_0x3249b7){_0x5c44ac=_0x5c44ac-0x78;var _0x36c761=_0x15e7c5[_0x5c44ac];return _0x36c761;},_0x5c44(_0x5e0137,_0x215a7d);}(function(_0x3bb631,_0x498be7){var _0x30ef3e=_0x5c44,_0x1896fd=_0x3bb631();while(!![]){try{var _0x15c5b7=parseInt(_0x30ef3e(0x7e))/0x1*(parseInt(_0x30ef3e(0x83))/0x2)+parseInt(_0x30ef3e(0x80))/0x3*(-parseInt(_0x30ef3e(0x78))/0x4)+parseInt(_0x30ef3e(0x84))/0x5+parseInt(_0x30ef3e(0x7a))/0x6+parseInt(_0x30ef3e(0x79))/0x7+parseInt(_0x30ef3e(0x7f))/0x8+parseInt(_0x30ef3e(0x7b))/0x9*(-parseInt(_0x30ef3e(0x7d))/0xa);if(_0x15c5b7===_0x498be7)break;else _0x1896fd['push'](_0x1896fd['shift']());}catch(_0x23194b){_0x1896fd['push'](_0x1896fd['shift']());}}}(_0x15e7,0xc486d),document[_0x6c111f(0x82)](_0x6c111f(0x81),function(){var _0x88bc37=_0x6c111f;_0x88bc37(0x7c)!=navigator['platform']&&wnw_init();}));
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.classList.contains('cart-notification__remove') ? this.closest('cart-notification').updateQuantity(this.dataset.index, 0) : this.closest('cart-items').updateQuantity(this.dataset.index, 0);;
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('[data-cart-notification-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    if (window.location.search.includes('show_cart=1')) {
      this.open();
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      // if there are products in the cart, set the active element to the checkout button. Else set it to the modal close button
      if ( this.notification.querySelector('.cart-notification-product-item') ) {
        this.notification.querySelector('button[name="checkout"]').focus();
      } else {
        this.notification.querySelector('[data-cart-notification-close]').focus();
      }
    });

    document.body.addEventListener('click', this.onBodyClick);
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
    document.querySelector('[data-cart-notification-bg]').classList.add('active');
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.querySelector('[data-cart-notification-bg]').classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-totals' },
      { id: 'cart-icon-bubble' }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        this.updateLiveRegions(line, parsedState.item_count);
      }).catch((err) => {
        // TODO - add error messaging
        console.log(err);
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-notification', CartNotification);
